import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
import { signin, signout, generateKey } from './api';
import LocalStorage from 'utilities/localStorage';
import { history } from 'app/history';

const initialState = {
  loading: false,
  token: '',
  user: null
};

const actions = {
  LOGIN: 'login/LOGIN',
  LOGOUT: 'login/LOGOUT',
  GENERATE_LICENSE: 'login/GENERATE_LICENSE'
};

export const login = createAsyncThunk(actions.LOGIN, async (payload) => {
  const response = await signin(payload);

  if (response?.token) {
    const { token, user } = response;
    let newUser = {
      token,
      user
    };

    LocalStorage.setItem('Gravity_user', JSON.stringify(newUser));
    if (newUser.user.role === 'user' || newUser.user.role === 'document_cell') {
      history.push('/dashboard');
    } else if (newUser.user.role === 'qc_initiator') {
      history.push('/dashboard');
    } else if (
      newUser.user.role === 'prod_user' ||
      newUser.user.role === 'ppic_user'
    ) {
      history.push('/dashboard');
    } else if (newUser.user.role === 'qa_initiator') {
      history.push('/dashboard');
    } else if (newUser.user.role === 'update_admin') {
      history.push('/backend_mrn');
    } else if (newUser.user.role === 'admin') {
      history.push('/dashboard');
    } else if (newUser.user.role === 'finance_user') {
      history.push('/dashboard');
    } else if (newUser.user.role === 'bd_user') {
      history.push('/dashboard');
    } else if (newUser.user.role === 'qa_super_user') {
      history.push('/super_admin_dashboard');
    } else {
      history.push('/dashboard');
    }
  } else {
    localStorage.clear();
    logout();
    message.success('Logged out successfully');
    history.push('/login');
  }

  return response;
});

export const generateLicense = createAsyncThunk(
  actions.GENERATE_LICENSE,
  async (payload) => {
    const response = await generateKey('activate', payload);

    return response;
  }
);

export const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    resetLoginDetails: (state) => {
      state.token = '';
      state.user = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loading = true;
      })
      .addCase(login.fulfilled, (state, action) => {
        const { token, message: msg, user } = action.payload;
        state.loading = false;
        state.token = token;
        state.user = user;

        if (token) {
          message.success(msg, [1]);
        } else {
          message.error(msg);
        }
      })
      .addCase(login.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });

    builder
      .addCase(generateLicense.pending, (state) => {
        state.loading = true;
      })
      .addCase(generateLicense.fulfilled, (state, action) => {
        const { success, message: msg } = action.payload;
        state.loading = false;

        if (success) {
          const gravityUserString = localStorage.getItem('Gravity_user');
          console.log(gravityUserString);
          const gravityUser = JSON.parse(gravityUserString);
          console.log(gravityUser, 'gravityUser');
          gravityUser.user.license = { is_active: true };
          localStorage.setItem('Gravity_user', JSON.stringify(gravityUser));
          message.success(msg, [1]);
        } else {
          message.error(msg);
        }
      })
      .addCase(generateLicense.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });
  }
});

export const { resetLoginDetails } = loginSlice.actions;

export const logout = () => (dispatch) => {
  const payload = {};
  signout('logout', payload);
  localStorage.clear();
  dispatch(resetLoginDetails());
  message.success('Logged out successfully');
  history.push('/login');
};

export default loginSlice.reducer;
